import { storage } from '@/src/general/utilities/storage'
import { STORAGE_KEYS } from '@/src/general/utilities/storage/MMKVStorage'

const DONATION_BANNER_TTL_MS = 48 * 60 * 60 * 1000 // 48h

type TDonationBannerPersistence = {
  expiresAt: number
}

export const donationBannerPersistence = {
  save() {
    const payload: TDonationBannerPersistence = {
      expiresAt: Date.now() + DONATION_BANNER_TTL_MS,
    }
    storage.setItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED, JSON.stringify(payload))
  },

  isActive() {
    const rawValue = storage.getItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
    if (!rawValue) return false

    try {
      const hasNotBeenDismissed: unknown = JSON.parse(rawValue)

      // Makes sure to handle legacy format: "true"
      if (hasNotBeenDismissed === 'true') {
        storage.removeItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
        return false
      }

      if (
        typeof hasNotBeenDismissed !== 'object' ||
        hasNotBeenDismissed === null ||
        !('expiresAt' in hasNotBeenDismissed) ||
        typeof hasNotBeenDismissed.expiresAt !== 'number'
      ) {
        storage.removeItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
        return false
      }

      if (hasNotBeenDismissed.expiresAt <= Date.now()) {
        storage.removeItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
        return false
      }

      return true
    } catch {
      // Invalid JSON in storage: drop it and treat the banner as dismissed
      storage.removeItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
      return false
    }
  },

  clear() {
    storage.removeItem(STORAGE_KEYS.DONATION_BANNER_NOT_BEEN_DISMISSED)
  },
}
